/*************************************************/
/* Partials                                      */
/*************************************************/
import { form } from "./partials/form.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector("body"),
    bodyLoadingClass = "is-loading";
    form(body, bodyLoadingClass);
});
